<div class="mx-auto max-w-(--breakpoint-2xl)">
@if (venuesPage) {
  <app-data-table
    (route)="this.handleRoute($event)"
    [title]="'Venues'"
    [dataPage]="venuesPage"
    [columns]="tableColumns"
    [rowActions]="rowActions">

    <div header class="flex flex-row items-center justify-end w-full gap-3">
      @if (isAdmin) {
        <a routerLink="/venues/create"
           class="h-12 text-theme-sm shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2.5 font-medium
            text-gray-700 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200">
          <lucide-icon [name]="PlusIcon"></lucide-icon>
          Add Venue
        </a>
      } @else {
        <button
          class="h-12 text-theme-sm shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-4 py-2.5 font-medium text-gray-400 cursor-not-allowed"
          disabled
          title="Only admins can add venues">
          <lucide-icon [name]="PlusIcon"></lucide-icon>
          Add Venue
        </button>
      }
    </div>
  </app-data-table>
}
</div>
